import { render, staticRenderFns } from "./ListPromotion.vue?vue&type=template&id=6e2b8fba"
import script from "./ListPromotion.vue?vue&type=script&lang=js"
export * from "./ListPromotion.vue?vue&type=script&lang=js"
import style0 from "./ListPromotion.vue?vue&type=style&index=0&id=6e2b8fba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports